
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { motion } from 'framer-motion';
import cn from 'classnames';

import { deletePushMessage } from '../../model/slice';
import { ANIMATION_PROPS, PushTypes } from '../../model/constants';
import { PushMessage as PushMessageProps } from '@/features/common/push/model/messages';

import cls from '../assets/styles.module.pcss';
import CloseIcon from '../assets/close.svg?react';
import AlertIcon from '../assets/alert.svg?react';
import InfoIcon from '../assets/info.svg?react';
import WarningIcon from '../assets/warning.svg?react';

interface Props {
  message: PushMessageProps
  id: string
}

export function PushMessage({ message, id }: Props) {
  const [timeout, setTimeoutFunc] = useState<number>();
  const dispatch = useDispatch();

  function deleteMessage() {
    dispatch(deletePushMessage(id));
    if (timeout) clearTimeout(timeout);
  }

  useEffect(() => {
    if (message.timer) {
      setTimeoutFunc(setTimeout(deleteMessage, message.timer));
    }
  }, []);

  return (
    <motion.div
      className={cn(cls.PushMessage, {
        [cls.PushMessageInfo]: message.type === PushTypes.INFO,
        [cls.PushMessageSuccess]: message.type === PushTypes.SUCCESS,
        [cls.PushMessageError]: message.type === PushTypes.ERROR,
        [cls.PushMessageAlert]: message.type === PushTypes.ALERT,
      })}
      {...ANIMATION_PROPS}
    >
      <div className={cls.PushMessageHeader}>
        <div className={cls.PushMessageTitle}>
          { message.type === PushTypes.INFO && <InfoIcon /> }
          { message.type === PushTypes.ALERT && <AlertIcon /> }
          { message.type === PushTypes.ERROR && <WarningIcon /> }
          { message.type === PushTypes.SUCCESS && null }
          {message.title}
        </div>

        <div className={cls.PushMessageClose} onClick={deleteMessage}>
          <CloseIcon />
        </div>
      </div>
      { message.text && (
        <div className={cls.PushMessageText}>
          { message.text }
        </div>
      ) }
    </motion.div>
  );
}
